function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 1.25rem;\n  font-size: ",
        ";\n  color: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  cursor: pointer;\n  outline: none;\n  transition: all 0.2s ease-in-out;\n  padding: 0;\n  min-width: auto;\n  background: none;\n  box-shadow: none;\n  height: auto;\n  color: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  gap: 0.5rem;\n  \n  &:hover {\n    background: none;\n  }\n  \n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { Eye } from 'lucide-react';
import { Heart } from 'lucide-react';
import { MessageSquare } from 'lucide-react';
import styled from '@emotion/styled';
var StatsContainer = styled.div(_templateObject(), function(props) {
    return props.theme.typography.fontSize.sm;
}, function(props) {
    return props.theme.textSecondary;
}, function(props) {
    return props.className && props.className;
});
var StatButton = styled.button(_templateObject1());
var ViewsButton = styled(StatButton)(_templateObject2(), function(props) {
    return props.theme.primary;
});
var LikesButton = styled(StatButton)(_templateObject3(), function(props) {
    return props.theme.error;
});
var CommentsButton = styled(StatButton)(_templateObject4(), function(props) {
    return props.theme.success;
});
/**
 * ProjectStats 컴포넌트 - 프로젝트의 조회수, 좋아요, 댓글 수를 표시합니다.
 * 
 * 아토믹 디자인의 분자(Molecule) 레벨 컴포넌트
 */ var ProjectStats = function(param) {
    var views = param.views, likes = param.likes, comments = param.comments, onLikeClick = param.onLikeClick, onCommentClick = param.onCommentClick, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className;
    return /*#__PURE__*/ React.createElement(StatsContainer, {
        className: className
    }, /*#__PURE__*/ React.createElement(ViewsButton, null, /*#__PURE__*/ React.createElement(Eye, {
        size: 16
    }), views.toLocaleString()), /*#__PURE__*/ React.createElement(LikesButton, {
        onClick: onLikeClick
    }, /*#__PURE__*/ React.createElement(Heart, {
        size: 16
    }), likes.toLocaleString()), /*#__PURE__*/ React.createElement(CommentsButton, {
        onClick: onCommentClick
    }, /*#__PURE__*/ React.createElement(MessageSquare, {
        size: 16
    }), comments.toLocaleString()));
};
export default ProjectStats;
